export const skills = [
  {
    id: 0,
    name: "Destreza",
    selected: false,
  },
  {
    id: 1,

    name: "Inteligência",
    selected: false,
  },
  {
    id: 2,
    name: "Disciplina",
    selected: false,
  },
]

export const status = [
  {
    id: 0,
    name: "Ativa",
    selected: false,
  },
  {
    id: 1,
    name: "Concluída",
    selected: false,
  },
  {
    id: 2,
    name: "Validada",
    selected: false,
  },  
  {
    id: 3,
    name: "Atrasada",
    selected: false,
  }
]